export default "__VITE_ASSET__Bo2yOC4f__"